import { useState } from "react";
import { projects } from "../mock";
import { useTranslation } from "react-i18next";
import { useInView } from "../hooks/useInView";

const Projects = () => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState(t('projects.all'));
  const [ref, inView] = useInView(0.1);
  const categories = [t('projects.all'), "Kitchen", "Bathroom", "Living Room", "Interior"];

  const filteredProjects = filter === t('projects.all')
    ? projects 
    : projects.filter(p => p.category === filter);

  return (
    <section id="projects" ref={ref} className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <h2 className={`anim-heading text-4xl md:text-5xl font-bold text-gray-900 mb-4 ${inView ? 'is-in' : ''}`}>
            {t('projects.title')}
          </h2>
          <div className="flex justify-center mb-4">
            <div className={`anim-heading-underline ${inView ? 'is-in' : ''}`} />
          </div>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-8">
            {t('projects.subtitle')}
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all duration-300 ${
                  filter === category
                    ? "bg-[#1a7a8a] text-white shadow-lg"
                    : "bg-white text-gray-700 hover:bg-gray-100"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, idx) => (
            <div
              key={project.id}
              className={`anim-card anim-fade-up group relative overflow-hidden rounded-lg shadow-lg hover:shadow-2xl aspect-square ${inView ? 'is-in' : ''}`}
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-300"></div>
              <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <div className="text-sm text-[#3da5ba] mb-1">{project.category}</div>
                <h3 className="text-xl font-bold">{project.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
